import Keycloak from 'keycloak-js';
import { environment } from '../../../environments/environment';

export const keycloak = new Keycloak({
	url: environment.keycloakServer,
	realm: environment.keycloakRealm,
	clientId: environment.keycloakClientId,
});
